import MoreButtonSkeleton from '../MoreButton/MoreButtonSkeleton';
import './HeroSectionSkeleton.scss';

const HeroSectionSkeleton = ({ page = 'HomePage', showRecentWork = true, showMoreButton = true }) => {
  return (
    <div className='hero__section__skeleton'>
      <div className='left__side__hero__section__skeleton'>
        <div className='hero__content__skeleton'>
          <div className='hero__accent__skeleton'></div>
          {[...Array(2)].map((_, index) => (
            <div key={index} className='hero__title__skeleton'></div>
          ))}
          <div className='hero__title__skeleton--primary'></div>
          {[...Array(3)].map((_, index) => (
            <div key={index} className='hero__subtitle__skeleton'></div>
          ))}
          <div className='hero__subtitle__skeleton--primary'></div>
          <div className='hero__button__skeleton'></div>
        </div>
        {showMoreButton && <MoreButtonSkeleton />}
      </div>
      <div className='right__side__hero__section__wrapper__skeleton'>
        <div className='hero__animation__skeleton'></div>
        <div className='right__side__hero__section__skeleton'>
          {page === 'HomePage' && showRecentWork && (
            <>
              <div className='all__work__skeleton'>
                <div className='all__work__text__skeleton'></div>
              </div>
              <div className='background__substrate__skeleton'>
                <div className='recent__work__skeleton'>
                  <div className='recent__work__content__skeleton'>
                    <div className='recent__work__accent__skeleton'></div>
                    <div className='recent__work__title__skeleton'></div>
                    <div className='recent__work__title__skeleton--primary'></div>
                    <div className='recent__work__subtitle__skeleton'></div>
                    <div className='recent__work__subtitle__skeleton--primary'></div>
                    <div className='recent__work__button__skeleton'></div>
                  </div>
                </div>
              </div>
            </>
          )}
          {page !== 'HomePage' && (
            <div className='background__substrate__skeleton'>
              <div className='recent__work__skeleton'>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default HeroSectionSkeleton;